<template>
  <div ref="inputbox">
    <textarea
      class="form-control sr__input"
      :class="{'sr__input--invalid': !this.valid}"
      style="overflow-y: hidden"
      lazy-formatter
      @input="autoTextareaHeight()"
      ref="textarea"
      v-model="value"
      :disabled="disable"
    ></textarea>

    <b-form-invalid-feedback :state="valid">
      {{invalidMsg}}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
export default {
  name: 'textAreaItem',
  props: {
    field: Object,
    disable: Boolean
  },
  data () {
    return {
      value: '',
      valid: true,
      invalidMsg: '',
      toValidate: true
    }
  },
  watch: {
    value () {
      this.checkValueIsValid()
      this.field.value = this.value
    }
  },
  methods: {
    autoTextareaHeight () {
      this.$nextTick(() => {
        this.$refs.textarea.style.height = 'auto'
        this.$refs.textarea.style.height = this.$refs.textarea.scrollHeight + 'px'
      })
    },
    checkValueIsValid (uiNotify = true) {
      if (!this.toValidate) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }
      if (this._isDestroyed) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (!this.value) {
        if (!uiNotify) {
          return false
        }

        this.valid = false
        this.invalidMsg = '欄位必填'
      } else {
        this.valid = true
        this.invalidMsg = ''
      }

      return this.valid
    }
  },
  created () {
    this.toValidate = this.field.validates?.presence
    this.value = this.field.value
  },
  mounted () {
    var top = this.$refs.inputbox.getBoundingClientRect().top

    if (this.toValidate) {
      this.$store.dispatch('pushValidateInfo', {
        id: this._uid,
        top: () => { return top },
        checkValueIsValid: this.checkValueIsValid
      })
    }

    this.autoTextareaHeight()
  }
}
</script>
